"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.LocalDealer = void 0;
const card_id_1 = require("../card/card-id");
const logic_metrics_1 = require("../logic-metrics");
const shuffler_1 = require("../../../common/shuffler");
const secret_value_to_string_1 = require("./secret-value-to-string");
class LocalDealer {
    constructor(secrets) {
        this.secrets = secrets;
        this.indexToHash = new Map();
    }
    static makeRandom() {
        const seed = Math.floor(new Date().getTime() / 1000);
        const cards = shuffler_1.Shuffler.shuffledDeck(seed, Array.from(Array(logic_metrics_1.LogicMetrics.DeckCards * logic_metrics_1.LogicMetrics.NumberDecks).keys()));
        const fixedIds = [];
        // const fixedIds = ['D8:3', 'D6:3', 'C8:3', 'S4:3', 'H8:3']; // Split 8's, then 8
        // const fixedIds = ['D5:3', 'D10:3', 'D6:3', 'C1:3', 'S4:3', 'H1:3']; // Split Ace's, then 21
        // const fixedIds = ['D8:3', 'D6:3', 'C11:3', 'S4:3', 'H1:3']; // Player blackjack
        const fixedIdsRaw = fixedIds.map((id) => new card_id_1.CardId(id).rawId);
        const replacementStartIndex = cards.length - fixedIds.length;
        const stackedIds = [
            ...cards.slice(0, replacementStartIndex),
            ...fixedIdsRaw,
        ];
        const isAceIds = stackedIds.map((id) => {
            const cardId = new card_id_1.CardId(id);
            return cardId.isAce ? 1 : 0;
        });
        const isValueTenIds = stackedIds.map((id) => {
            const cardId = new card_id_1.CardId(id);
            return cardId.isValuedTen ? 1 : 0;
        });
        return new LocalDealer([...stackedIds, ...isAceIds, ...isValueTenIds]);
    }
    discloseSecrets(indexes, gameHash, _existingDeal) {
        try {
            for (const index of indexes) {
                if (!this.indexToHash.has(index)) {
                    this.indexToHash.set(index, gameHash);
                }
            }
            return Promise.resolve(indexes.map((index) => (0, secret_value_to_string_1.secretValueToString)({ index, value: this.secrets[index] })));
        }
        catch (error) {
            return Promise.reject(error);
        }
    }
    attestation() {
        const secrets = this.secrets;
        return {
            secrets: this.secrets.map((value, index) => ({
                value,
                index,
            })),
            disclosures: Array.from(this.indexToHash).map((entry) => ({
                index: entry[0],
                hash: entry[1],
                value: secrets[entry[0]],
            })),
        };
    }
}
exports.LocalDealer = LocalDealer;
